// extracted by mini-css-extract-plugin
export var container = "socials-module--container--3Zkkz";
export var img = "socials-module--img--R4iaw";
export var row = "socials-module--row--tU3Pv";
export var wrapper = "socials-module--wrapper--2ZVKK";